import _xss, { type IFilterXSSOptions } from 'xss'
const typeMap: Record<string, IFilterXSSOptions> = {
  default: {
    whiteList: {
      img: ['class', 'src', 'width', 'height', 'alt'],
      p: [],
      a: ['class', 'target', 'href', 'title', 'rel', 'aria-label'],
      br: [],
      strong: [],
      em: [],
      u: [],
      del: [],
      span: []
    }
  },
  article: {
    whiteList: {
      img: ['class', 'src', 'width', 'height', 'alt'],
      p: [],
      a: ['class', 'target', 'href', 'title', 'rel', 'aria-label'],
      br: [],
      strong: [],
      em: [],
      u: [],
      del: [],
      h1: [],
      h2: [],
      h3: [],
      h4: [],
      h5: [],
      h6: [],
      span: []
    }
  },
  comment: {
    whiteList: {
      img: ['class', 'src', 'width', 'height', 'alt'],
      p: [],
      a: ['class', 'target', 'href', 'title', 'rel', 'aria-label'],
      br: [],
      strong: [],
      em: [],
      u: [],
      del: [],
      span: []
    }
  }
}
export function xss(html: string, type?: 'article' | 'comment') {
  return _xss(html, typeMap[type || 'default'])
}
